import React, { useEffect, useState } from "react";
import OtpInput from "react-otp-input";
import "../styles/OtpVerificationStyles.css";
import { useLocation, useNavigate } from "react-router-dom";
import BackImg from "../assets/cameracheck/back.png";
import strings from "../../../utils/Strings";
import { useApi } from "../../../service/ApiContext";
import assessmentBackIcon from "../../dashboard/assets/dashboardBackArrow.png";
import { useAlert } from "../../../components/AlertContextComponent";
import Loader, { LocalStorage } from "../../../utils/Utils";
import { useDispatch, useSelector } from "react-redux";
import {
  setAssessmentId,
  setDuration,
  setStatus,
} from "../data/redux/AssessmentSlice";
import Logger from "../../../utils/Logger";
import { RootState } from "../../../store/store";
import {
  AssessmentStatusConfig,
  ForgotPasswordResponse,
} from "../data/response/AssessmentStatusResponse";
import AssessmentDetailsComponent from "../components/AssessmentDetailsComponent";

const OTPVerificationVersionTwo = () => {
  const [otp, setOtp] = useState("");
  const [isChildWindowOpen, setIsChildWindowOpen] = useState(false);
  const [isOtpValid, setIsOtpValid] = useState(false); // Track OTP validity
  const [modalShow, setModalShow] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalContent, setModalContent] = useState<React.ReactNode>("");
  const api = useApi();
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const assessmentConfig = process.env.REACT_APP_ASSESSMENT_CONFIG;
  const userData = useSelector((state: RootState) => state.profile.profileKeys); //To show favicon & title
  const handleGoBack = () => {
    navigate(-1);
  };
  const [isChecked, setIsChecked] = useState(false);
  const profileData = useSelector(
    (state: RootState) => state.profile.profileKeys,
  );
  const handleNextClick = () => {
    // openNewWindow();
    handleOpenChildWindow();

    if (isOtpValid) {
      handleOpenChildWindow();
    }
  };
  //   const handleShowModal = (title: string) => {
  //     setModalTitle(title);
  //     if (title === strings.modal.Terms) {
  //       setModalContent(
  //         <div>
  //           <ul>
  //             <li>
  //               The assessment is only used to develop and mature the platform and
  //               not for anyone's consumption.
  //             </li>
  //             <li>
  //               The data collected will be used to build and enhance our platform.
  //             </li>
  //             <li>
  //               The email information for the user is used only to send the
  //               assessment report and not for any marketing purpose at this point
  //               in time.
  //             </li>
  //             <li>
  //               The user can unsubscribe from the assessment report at any time by
  //               clicking the "Unsubscribe" button.
  //             </li>
  //           </ul>
  //         </div>,
  //       );
  //     }

  //     setModalShow(true);
  //   };

  //new window component implementation starts
  const [blurCount, setBlurCount] = useState(0); // To track how many times the user goes out
  //Tab Changes detection
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isForcedExit, setIsForcedExit] = useState(false); // Indicates user has been logged out
  const handleOpenChildWindow = () => {
    setIsChildWindowOpen(true);
  };

  //new window component implementation ends
  const location = useLocation();
  const selectedAssessment = location.state?.selectedAssessment;

  const handleOTPValidate = async () => {
    Loader.showLoading("Loading...");
    setLoading(true);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    Logger.info(
      "Selected Assessment ID ",
      selectedAssessment?.assessment_entity_id,
    );
    const url = `/assessment/otp/validate?otp=${otp}&assessment_entity_id=${selectedAssessment?.assessment_entity_id}`;

    try {
      const response = await api.post<ForgotPasswordResponse>(url);
      if (response.data.detail) {
        setIsOtpValid(true); // OTP is valid

        // Show success popup
        // showAlert({
        //   show: true,
        //   title: "Successsss",
        //   message: response.data.detail,
        //   alertType: "success",
        //   onlyNeedOneButton: true,
        //   button1Text: "OK",
        // });
        if (response.data.detail.includes("Assessment already started")) {
          showAlert({
            identity: "",
            show: true,
            title: "Error",
            message: response.data.detail,
            alertType: "error",
            onlyNeedOneButton: true,
            button1Text: "Ok",
            btn1onPressed: () => {
              // navigate("/dashboard/assessment/allAssessment/instruction");
            },
          });
          setIsOtpValid(false);
          setIsChecked(false);
        } else {
          await handleStartAssessment();
        }
      } else if (response.data.error) {
        // Show error popup
        setIsOtpValid(false); // OTP is invalid
        showAlert({
          identity: "",

          show: true,
          title: "Error",
          message: response.data.error,
          alertType: "error",
          onlyNeedOneButton: true,
          button1Text: "Cancel",
          btn1onPressed: () => {
            // navigate("/dashboard/assessment/allAssessment/instruction/otp");
          },
        });
      }
    } catch (error) {
      setIsOtpValid(false);
    } finally {
      Loader.dismissLoading();
      setLoading(false);
    }
  };
  const dispatch = useDispatch();

  const handleStartAssessment = async () => {
    Loader.showLoading("Loading...");
    setLoading(true);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    const configName = assessmentConfig; // Retrieved from the environment variable
    const startUrl = `/assessment/start?config_name=${process.env.REACT_APP_ASSESSMENT_CONFIG}&assessment_entity_id=${selectedAssessment?.assessment_entity_id}`;

    try {
      const startResponse = await api.post<AssessmentStatusConfig>(startUrl);

      if (startResponse.data) {
        dispatch(setStatus(startResponse.data.status));
        dispatch(setAssessmentId(startResponse.data.assessment_id));
        dispatch(setDuration(startResponse.data.duration));
        Logger.info("assessmentid", startResponse.data.assessment_id);
        // Handle success for starting the assessment
        startResponse.data.duration &&
          LocalStorage.setLocalData(
            strings.localStorage_keys.assessment_details.duration,
            startResponse.data.duration.toString(),
          );
        startResponse.data.status &&
          LocalStorage.setLocalData(
            strings.localStorage_keys.assessment_details
              .candidate_assessment_status,
            startResponse.data.status,
          );
        startResponse.data.assessment_id &&
          LocalStorage.setLocalData(
            strings.localStorage_keys.assessment_details.assessment_id,
            startResponse.data.assessment_id.toString(),
          );
        startResponse.data.total_question &&
          LocalStorage.setLocalData(
            strings.localStorage_keys.assessment_details.total_question,
            startResponse.data.total_question.toString(),
          );
      }
    } catch (error) {
      // Handle errors for the startAssessment API
      showAlert({
        identity: "",
        show: true,
        title: "Error",
        message: "Failed to start the assessment. Please try again later.",
        alertType: "error",
        onlyNeedOneButton: true,
        button1Text: "OK",
      });
    } finally {
      Loader.dismissLoading();
      setLoading(false);
    }
  };

  const handleEmailLinkClick = async () => {
    Loader.showLoading("Loading...");
    setLoading(true);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.post<ForgotPasswordResponse>(
        "/assessment/otp/generate",
      ); // Assuming `otp` is required
      if (response.data.detail) {
        // Show success popup
        showAlert({
          identity: "",
          show: true,
          title: "Success",
          message: response.data.detail,
          alertType: "success",
          onlyNeedOneButton: true,
          button1Text: "OK",
          btn1onPressed: () => {
            // navigate("/dashboard/assessment/allAssessment/instruction/otp");
          },
        });
      } else if (response.data.error) {
        // Show error popup
        showAlert({
          identity: "",
          show: true,
          title: "Error",
          message: response.data.error,
          alertType: "error",
          onlyNeedOneButton: true,
          button1Text: "OK",
          btn1onPressed: () => {},
        });
      }
    } catch (error) {
      // Handle network or server errors
      showAlert({
        identity: "",
        show: true,
        title: "Error",
        message: "An unexpected error occurred. Please try again later.",
        alertType: "error",
        onlyNeedOneButton: true,
        button1Text: "OK",
      });
    } finally {
      Loader.dismissLoading();
      setLoading(false);
    }
  };

  const handleClose = () => {
    setModalShow(false);
  };
  // Automatically trigger OTP validation once all 4 digits are entered
  useEffect(() => {
    if (otp.length === 4) {
      handleOTPValidate();
    }
  }, [otp]);

  return (
    <div
      style={
        {
          // margin: "20px",
        }
      }
    >
      <div className="assessment-header">
        <div className="header-content">
          <img
            src={BackImg}
            className="back-btn"
            onClick={() => {
              navigate(-1);
            }}
          ></img>
          <span className="title">{"Assessment"}</span>
        </div>
        <div className="divider" />
      </div>
      {/* <div className="v2-assessmentOtpHeader">
        <img
          src={assessmentBackIcon}
          alt=""
          onClick={() => {
            navigate(-1);
          }}
          style={{ height: "30px", width: "30px", cursor: "pointer" }}
        />{" "}
        Assessment
      </div> */}
      <div className="v2-assessmentOtpPage">
        {/* <div className="v2-leftAssessmentCard"> */}
        <AssessmentDetailsComponent selectedAssessment={selectedAssessment} />
        {/* </div> */}

        <div className="v2-rightAssessmentOtp">
          <div className="v2-otp-card">
            {/* TOP CONTENT */}
            <div className="v2-otp-top">
              <h2 className="v2-otp-title">
                All the best! {profileData.first_name} {profileData.last_name}
                ...
              </h2>

              <p className="v2-otp-subtitle">Do you have assessment code?</p>

              <OtpInput
                value={otp}
                onChange={setOtp}
                numInputs={4}
                containerStyle="v2-otp-container"
                renderInput={(props) => (
                  <input
                    {...props}
                    className="v2-otp-input"
                    type="number" // ✅ change here
                    inputMode="numeric" // ✅ ensures number keypad
                  />
                )}
              />

              {/* <div className="v2-otp-checkbox">
                <input
                  type="checkbox"
                  checked={isChecked}
                  style={{
                    height: "20px",
                    accentColor: "#044472",
                    width: "20px",
                  }}
                  onChange={(e) => setIsChecked(e.target.checked)}
                />
                <span>I’m not a robot</span>
              </div> */}
            </div>

            {/* BOTTOM CONTENT */}
            <div className="v2-otp-bottom">
              <button
                className="v2-otp-btn"
                // disabled={!isChecked || !isOtpValid}
                disabled={!isOtpValid}
                onClick={() => {
                  navigate("/dashboard/assessment/instruction", {
                    state: {
                      selectedAssessment: selectedAssessment, // pass your full list here
                    },
                  });
                }}
              >
                Go to next
              </button>
              <p
                className="v2-otp-later"
                onClick={() => {
                  navigate("/dashboard/assessment");
                }}
              >
                Let me do it later
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OTPVerificationVersionTwo;
